import script from "./CheckBox.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckBox.vue?vue&type=script&setup=true&lang=js"

import "./CheckBox.vue?vue&type=style&index=0&id=5878c2fe&scoped=true&lang=css"

import exportComponent from "/Users/alberto/sites/newform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5878c2fe"]])

export default __exports__